export default {
  player: {
    tooltips: {
      fullscreen: 'Les actions sont désactivées en mode plein écran',
    },
  },
  massDelete: 'Supprimer les listes de lecture',
  massEnable: 'Activer les listes de lecture',
  massDisable: 'Désactiver les listes de lecture',
};
